<script>
export default {
  name: "Badge",
  props: {
    label: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        ["success", "info", "warning", "danger", "secondary"].includes(value),
    },
  },
};
</script>

<template>
  <b-badge class="badge-component" :variant="variant">
    {{ label }}
  </b-badge>
</template>

<style lang="scss" scoped>
.badge-component {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 20px;

  &.badge-success {
    color: #005952;
    background: #e1f4f3;
  }

  &.badge-info {
    color: #1a52db;
    background: #eff6ff;
  }

  &.badge-warning {
    color: #9e610a;
    background: #fefce8;
  }

  &.badge-danger {
    color: #c71307;
    background: #fff3ed;
  }

  &.badge-secondary {
    color: #323a46;
    background: #ededed;
  }
}
</style>
